import {React, observer} from '@api'
import {Button} from '@blueprintjs/core'
import {SnackbarContent} from '@material-ui/core'
import {usePdfStore} from '@modules/pdf/PdfExportStore'
import {PdfSvgIcon} from '@stores/ui'
import * as css from './FrozenPdfDocumentMessage.css'

export const FrozenPdfDocumentSnackbarContent = observer(() => {
  const {undo} = usePdfStore()
  return (
    <SnackbarContent
      className={css.snackbarContent}
      classes={{message: css.message, action: css.action}}
      action={<div className={css.buttons}>
        <Button minimal onClick={undo.commit} text='Update Now'/>
        <Button minimal
                className='cancel' active onClick={undo.rollback} text='Revert'/>
      </div>}
      message={<div className={css.root}>
        <PdfSvgIcon className={css.icon}/>
        <div className={css.text}>
          <div className={css.heading}>Your PDF is out of date</div>
          {/*{!isDirty && <div className={css.subheading}>Changes will be applied in {unfreezeSecsRemaining}s</div>}*/}
        </div>
      </div>}
    />)
})



// WEBPACK FOOTER //
// ./src/modules/pdf/FrozenPdfDocumentMessage.tsx